import { Request } from "./HttpService";

export const PromtAiService = {
  getQuery(prompt, searchConfig) {
    let obj = {};

    Object.keys(searchConfig).map((key) => {
      obj[key] = {
        operations: searchConfig[key].operation,
        values: searchConfig[key].list
      };
    });
    return Request(`vitae/interviewAdvanceSearch/GetSearchExpression`, "POST", {
      prompt: prompt,
      fieldRules: obj
    });
  }
};
